import React, { useState } from 'react';
import classNames from 'classnames';

import {
  trackPeopleEditPerson,
  trackPeopleDeletePerson,
} from '../../../../analytics';

import { Spinner } from '../../../../components/general';

import { deleteFace } from '../../../../services/api/faces';

import { Person } from '../../../../types';
import { isEmpty } from '../../../../utils';

import FaceCircle from '../../components/faceCircle';
import { UploadingPeople } from '../../components/types';
import EditPersonModal from './editPersonModal';

interface Props {
  people: Person[];
  uploadingPeople?: UploadingPeople;
  deletingPeopleIds?: string[];
  setDeletingPeopleIds?: React.Dispatch<React.SetStateAction<string[]>>;
  fetchPeopleData?: (checkPhotos?: boolean) => void;
  isPublic?: boolean;
  isShowDetails?: boolean;
  isSample?: boolean;
  toggleSamplePerson?: (id: string, isAdd?: boolean) => void;
}

const PeopleSummary: React.FC<Props> = (props) => {
  const {
    people = [],
    uploadingPeople = {},
    deletingPeopleIds,
    setDeletingPeopleIds,
    fetchPeopleData,
    isPublic,
    isShowDetails,
    isSample,
    toggleSamplePerson,
  } = props;

  const [openedPersonId, setOpenedPersonId] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);

  const handleClick = (id: string | null) => {
    if (isSample) {
      toggleSamplePerson && id && toggleSamplePerson(id);
    } else if (!!id) {
      setShowModal(true);
      setOpenedPersonId(id);
      trackPeopleEditPerson();
    } else {
      setShowModal(false);
      setTimeout(() => setOpenedPersonId(null), 500);
    }
  };

  const handleDelete = async (person: Person) => {
    // add elementId to list of deleting selects
    if (setDeletingPeopleIds && deletingPeopleIds)
      setDeletingPeopleIds([...deletingPeopleIds, person.face.elementId]);

    // delete person
    await deleteFace(person.face.elementId, isPublic);

    // refetch people data
    fetchPeopleData && fetchPeopleData();

    trackPeopleDeletePerson();
  };

  const uploadingPeopleArray = Object.keys(uploadingPeople).map(
    (id: string) => uploadingPeople?.[id],
  );
  if (isEmpty(people) && isEmpty(uploadingPeopleArray)) return null;

  return (
    <div
      className={classNames('flex flex-row flex-wrap', {
        'gap-6': !isShowDetails,
      })}
    >
      {people.map((person) => (
        <FaceCircle
          key={person.face.elementId}
          person={person}
          onClick={() => handleClick(person.face.elementId)}
          onDelete={isSample ? undefined : () => handleDelete(person)}
          deletingFacesIds={deletingPeopleIds}
          isBig
          isShowDetails={isShowDetails}
          isSample={isSample}
        />
      ))}

      {uploadingPeopleArray.map((person, index) => {
        return (
          <div className="w-[var(--upload-el-width)]" key={index}>
            <Spinner customSize="w-full" color="primary" />

            <div className="w-full text-center mt-2 whitespace-nowrap overflow-hidden text-ellipsis">
              {person.face.name}
            </div>
          </div>
        );
      })}

      <EditPersonModal
        show={showModal}
        people={people}
        openedPersonId={openedPersonId}
        togglePersonModal={handleClick}
        fetchPeopleData={fetchPeopleData}
      />
    </div>
  );
};

export default PeopleSummary;
